import React from 'react';
import Slider from 'react-slick';

import { useAppContext } from '../../lib/context';
import useLanguage from '../../hooks/useLanguage';

const SliderCommon = () => {
  const [app] = useAppContext();

  const formatMessage = useLanguage();

  const settings = {
    dots: false,
    infinite: true,
    slidesToShow: 5,
    arrows: false,
    slidesToScroll: 1,
    autoplay: true,
    speed: 2000,
    autoplaySpeed: 5000,
    cssEase: 'linear',
    responsive: [
      {
        breakpoint: 1535,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
          infinite: true,
          dots: false,
        },
      },
      {
        breakpoint: 1279,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: true,
          dots: false,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          initialSlide: 3,
          dots: false,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          dots: false,
        },
      },
      {
        breakpoint: 380,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          dots: false,
        },
      },
    ],
  };

  return (
    <div className="bg-[#F8FBFB] dark:bg-[#0D0D0D] max-w-full h-auto py-3 rounded-xl">
      <h3 className="text-center dark:text-white text-2xl mb-3 font-semibold ">
        {formatMessage('info.ourCustomers')}
      </h3>
      <Slider {...settings}>
        {/* slider array */}

        {app.data.works.map((item, i) => (
          <img
            key={i}
            className=" overflow-hidden brand-img"
            src={item.logo}
            alt={item.name}
          />
        ))}
      </Slider>
    </div>
  );
};

export default SliderCommon;
